import React from "react";
import Search from "../Search/index";
import NavItem from "../NavItem";
import SchemaSideMenu from "../SchemaSideMenu";
import * as Constants from "../../constants/Constants";
import SubHeader from "../SubHeader";

const ApiDetailSideMenu = ({menu}) => {
  return (
    <div className="side-wrapper side-menu-layout">
      <div className="side-wrapper-body">
        <SubHeader component={Constants.Values.VIEW_DOCUMENTATION}/>
        <div className="search">
          <Search data={menu}/>
        </div>
        {menu.map(({header, subEntities, schemas}, menuIndex) => {
          return (
            <NavItem
              key={header}
              header={header}
              subEntities={subEntities}
              schemas={schemas}
              menuIndex={menuIndex}
            />
          );
        })}
        <SchemaSideMenu menu={menu}/>
      </div>
    </div>
  );
};

export default ApiDetailSideMenu;
